import { Nav, Tab } from "react-bootstrap";
import { ILicenceActionDetails } from "../../../api/ILicensingAction";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  licenceActionDetails: ILicenceActionDetails;
  licenceProfile: ILicenceProfile;
}

interface FurtherInformationProps {
  licenceActionDetails: ILicenceActionDetails;
  licenceProfile: ILicenceProfile;
}

const SubTabs = ({
  className,
  activeKey,
  licenceActionDetails,
  licenceProfile,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid
            regardingObjectId={licenceActionDetails.licenceactionid}
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const FurtherInformation = ({
  licenceActionDetails,
  licenceProfile,
}: FurtherInformationProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="documents"
      licenceActionDetails={licenceActionDetails}
      licenceProfile={licenceProfile}
    />
  );
  return <EpaCard title={"Further Information"} content={bodyElements} />;
};

export default FurtherInformation;
